import IsrealCircleIcon from '../../assets/icons/languages/israel.png'
import USACircleIcon from '../../assets/icons/languages/united-states.png'
import GermanCircleIcon from '../../assets/icons/languages/germany.png'
import SwissCircleIcon from '../../assets/icons/languages/switzerland.png'
import CanadaCircleIcon from '../../assets/icons/languages/canada.png'
import GreeceCircleIcon from '../../assets/icons/languages/greece.png'
import PhilippinesCircleIcon from '../../assets/icons/languages/philippines.png'
import SingaporeCircleIcon from '../../assets/icons/languages/singapore.png'
import AustriaCircleIcon from '../../assets/icons/languages/austria.png'
import PortugalCircleIcon from '../../assets/icons/languages/portugal.png'
import BelgiumCircleIcon from '../../assets/icons/languages/belgium.png'
import AustraliaCircleIcon from '../../assets/icons/languages/australia.png'
import IrelandCircleIcon from '../../assets/icons/languages/ireland.png'
import SpainCircleIcon from '../../assets/icons/languages/spain.png'
import NetherlandsCircleIcon from '../../assets/icons/languages/netherlands.png'
import FinlandCircleIcon from '../../assets/icons/languages/finland.png'
import ItalyCircleIcon from '../../assets/icons/languages/italy.png'
import ChinaCircleIcon from '../../assets/icons/languages/china.png'
import JapanCircleIcon from '../../assets/icons/languages/japan.png'
import PolandCircleIcon from '../../assets/icons/languages/poland.png'
import BrazilCircleIcon from '../../assets/icons/languages/brazil.png'
import NewZealandCircleIcon from '../../assets/icons/languages/new-zealand.png'
import LuxembourgCircleIcon from '../../assets/icons/languages/luxembourg.png'
import FranceCircleIcon from '../../assets/icons/languages/france.png'
import CzechCircleIcon from '../../assets/icons/languages/czech-republic.png'
import SwedenCircleIcon from '../../assets/icons/languages/sweden.png'
import RussiaCircleIcon from '../../assets/icons/languages/russia.png'
import MexicoCircleIcon from '../../assets/icons/languages/mexico.png'
import UKCircleIcon from '../../assets/icons/languages/united-kingdom.png'
import BulgariaCircleIcon from '../../assets/icons/languages/bulgaria.png'
import RomaniaCircleIcon from '../../assets/icons/languages/romania.png'
import DenmarkCircleIcon from '../../assets/icons/languages/denmark.png'
import TaiwanCircleIcon from '../../assets/icons/languages/taiwan.png'
import { ELanguage } from 'types/enums/ELanguage'

export type Language = {
  code: ELanguage
  flagImagePath: string
}

export type Country = {
  code: ELanguage
  flagImagePath: string
  regex: RegExp
}

export const languages: Language[] = [
  {
    code: ELanguage.HEBREW,
    flagImagePath: IsrealCircleIcon,
  },
  {
    code: ELanguage.ENGLISH,
    flagImagePath: USACircleIcon,
  },
]

const countries: Country[] = [
  {
    code: ELanguage.HEBREW,
    flagImagePath: IsrealCircleIcon,
    regex: /^[A-Za-z0-9<>()\\\-:/\s]{8,20}$/,
  },
  {
    code: ELanguage.ENGLISH,
    flagImagePath: USACircleIcon,
    regex: /^[A-Za-z]{1}\d{8}$/,
  },
  {
    code: ELanguage.GERMAN,
    flagImagePath: GermanCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{9}D^A-Za-z0-9$/,
  },
  {
    code: ELanguage.SWISS,
    flagImagePath: SwissCircleIcon,
    regex: /^A-Za-z\d{7}\D$/,
  },
  {
    code: ELanguage.CANADA,
    flagImagePath: CanadaCircleIcon,
    regex: /^A-Za-z{2}\d{6,7}\D$/,
  },
  {
    code: ELanguage.GREECE,
    flagImagePath: GreeceCircleIcon,
    regex: /^A-Za-z{2}\d{7}\D$/,
  },
  {
    code: ELanguage.PHILIPPINES,
    flagImagePath: PhilippinesCircleIcon,
    regex: /^A-Za-z0-9{7}A-Za-z^A-Za-z$/,
  },
  {
    code: ELanguage.SINGAPORE,
    flagImagePath: SingaporeCircleIcon,
    regex: /^A-Za-z0-9{7}A-Za-z^A-Za-z$/,
  },
  {
    code: ELanguage.AUSTRIA,
    flagImagePath: AustriaCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{7}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.PORTUGAL,
    flagImagePath: PortugalCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{6}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.BELGIUM,
    flagImagePath: BelgiumCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{7}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.AUSTRALIA,
    flagImagePath: AustraliaCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{7}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.IRELAND,
    flagImagePath: IrelandCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{6}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.SPAIN,
    flagImagePath: SpainCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{7,8}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.NETHERLANDS,
    flagImagePath: NetherlandsCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{8}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.FINLAND,
    flagImagePath: FinlandCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{8}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.ITALY,
    flagImagePath: ItalyCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{8}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.CHINA,
    flagImagePath: ChinaCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{8,9}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.JAPAN,
    flagImagePath: JapanCircleIcon,
    regex: /^A-Za-zA-Za-z0-9{8,10}^A-Za-z0-9$/,
  },
  {
    code: ELanguage.POLAND,
    flagImagePath: PolandCircleIcon,
    regex: /^A-Z{2}0-9{7}\D$/,
  },
  {
    code: ELanguage.BRAZIL,
    flagImagePath: BrazilCircleIcon,
    regex: /^A-Z{2}0-9{6}\D$/,
  },
  {
    code: ELanguage.NEW_ZEALAND,
    flagImagePath: NewZealandCircleIcon,
    regex: /^A-Z{2}0-9{6}\D$/,
  },
  {
    code: ELanguage.LUXEMBOURG,
    flagImagePath: LuxembourgCircleIcon,
    regex: /^IA-Za-z0-9{5}\d\D$/,
  },
  {
    code: ELanguage.FRANCE,
    flagImagePath: FranceCircleIcon,
    regex: /^\d{2}A-Za-z0-9{2}\d{5}\D$/,
  },
  { code: ELanguage.CZECH, flagImagePath: CzechCircleIcon, regex: /^\d{8}\D$/ },
  {
    code: ELanguage.SWEDEN,
    flagImagePath: SwedenCircleIcon,
    regex: /^\d{8}\D$/,
  },
  {
    code: ELanguage.RUSSIA,
    flagImagePath: RussiaCircleIcon,
    regex: /^\d{10}\D$/,
  },
  {
    code: ELanguage.MEXICO,
    flagImagePath: MexicoCircleIcon,
    regex: /^\d{10,11}\D$/,
  },
  { code: ELanguage.UK, flagImagePath: UKCircleIcon, regex: /^\d{9}\D$/ },
  {
    code: ELanguage.BULGARIA,
    flagImagePath: BulgariaCircleIcon,
    regex: /^\d{9}\D$/,
  },
  {
    code: ELanguage.ROMANIA,
    flagImagePath: RomaniaCircleIcon,
    regex: /^\d{9}\D$/,
  },
  {
    code: ELanguage.DENMARK,
    flagImagePath: DenmarkCircleIcon,
    regex: /^\d{9}\D$/,
  },
  {
    code: ELanguage.TAIWAN,
    flagImagePath: TaiwanCircleIcon,
    regex: /\b\d{9}\b|\b3\d{8}\b/,
  },
]

export default countries
